import { Component, OnInit } from '@angular/core';

import {
    CommonComponent,
    CommonElementsConfig,
} from '../../common/common.component';

@Component({
    selector: 'app-dialog-ledger-request-refund',
    templateUrl: '../../common/common.component.html',
    styleUrls: ['../../common/common.component.css'],
})
export class RefundComponent extends CommonComponent implements OnInit {
    public override elements = new CommonElementsConfig(['comment']);

    public override submitLabel = 'Request';
    public override headingLabel = 'Request Refund';

    public override submit() {
        this.message = undefined;
        if (this.formGroup.valid == false) {
            this.message = 'All form fields are required';
            return;
        }

        let payload = {
            request_type: 'refund',
            transaction_id: Number(this.transactionModel!.id),
            comment: this.formGroup.get('comment')!.value,
        };

        this.sendPayload('ledger/request', payload);
    }
}
